// extracted by mini-css-extract-plugin
export default {"container":"SectionHeader_container__yWdVV","iconWrapper":"SectionHeader_iconWrapper__051hz"};